import { InjectedConnector } from '@web3-react/injected-connector'

export class InjectedFakeHardwareConnector extends InjectedConnector {}
